<template>
  <ComContainer>
    <div>
      <DeclareCheck :bfStateName="bfStateName" :talentDiff="talentDiff" @changeAffix="handleChangeAffix"></DeclareCheck>
      <div class="com-progress" :class="showSmallRow ? 'smallHeight' : 'normalHeight'">
        <ComSteps :bfStateName="bfStateName" :completeSelection="completeSelection"></ComSteps>
      </div>
      <div class="tabs-wrapper common-tab-line" >
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" tab="基础信息">
            <InstitutionBasicInfo
              :id="$route.query.id"
              :isEdit="$route.query.isEdit == 'true'"
              :current="$route.query.current"
              :status="$route.query.status"
              @changeCompleteSelection="changeCompleteSelection"
              @changeBfstate="changeBfstate"
              @changeTalentDiff="changeTalentDiff"
              @changeoriginalId="changeoriginalId"
              @changeAppealIds="changeAppealIds"
            ></InstitutionBasicInfo>
          </a-tab-pane>
          <a-tab-pane v-if="list.length>0"  key="2" tab="申诉过程">
            <appeal-info :list="list"></appeal-info>
          </a-tab-pane>
        </a-tabs>
      </div>
      <a-button v-if="isAdjusted === 0 && originalId" @click="openBasicInfo" class="btn-before" type="primary">查看调剂前数据</a-button>
      <!-- <a-modal
      width="1180px"
          title="调剂前基本信息"
          :visible="visibleBasicInfo"
          @ok="handleOk"
          @cancel="handleCancel"
          :footer = 'null'
        >
        <InstitutionBasicInfo
                :id="originalId"
                :isEdit="$route.query.isEdit == false"
              ></InstitutionBasicInfo>
        </a-modal> -->
    </div>
  </ComContainer>
</template>
<script>
import ComSteps from '@/components/common/com-steps.vue';
import {getAppealDetail} from '@/api/appeal'
import AppealInfo from '@/components/com-appeal/info.vue';
import ComContainer from '@/components/common/com-container.vue';
import InstitutionBasicInfo from '@/components/institution-basic-info/index.vue';
import DeclareCheck from './com-check/check.vue';
export default {
  name:"DeclareCheckInst",
  components: {
    ComContainer,
    DeclareCheck,
    InstitutionBasicInfo,
    AppealInfo,
    ComSteps
  },
  data() {
    return {
      isAdjusted:'',
      originalId:'',
      visibleBasicInfo:false,
      showSmallRow:false,
      list:[],
      bfStateName:'',
      completeSelection:'',
      talentDiff:'',
    };
  },
  mounted(){
    // let {postId,declarerId}=this.$route.query;
    // if(postId && declarerId){
    //   this.getCheckAppealDetail(postId,declarerId);
    // }
  },
  methods: {
    // isAdjusted： 1 - 被调剂 0 - 未被调剂
    // originalId：原申报数据id
    // 如果为0 没有id 说明没有被调剂过
    // 如果为1 没有id 说明是被调剂原数据
    // 如果为0 有id 说明是调剂后的新数据
    changeoriginalId(isAdjusted, originalId){
      this.isAdjusted = isAdjusted
      this.originalId = originalId
    },
    openBasicInfo(){
        this.$router.push({ path: '/institution/talent-transfer-lists/four-detail', query: { page: 'employed',  basicId: this.originalId,backPage:'true',adjustNumber:this.$route.query.adjustNumber?this.$route.query.adjustNumber:2 } })
    },
    handleCancel(){
      this.visibleBasicInfo = false;
    },
    handleOk(){
      this.visibleBasicInfo = false;
    },
        // 更改bFstate
    changeCompleteSelection(completeSelection) {
      this.completeSelection = completeSelection
    },
        // 更改bFstate
    changeBfstate(bfStateName) {
      this.bfStateName = bfStateName
    },
    changeTalentDiff(talentDiff) {
      this.talentDiff = talentDiff
      console.log(this.talentDiff, 'this.talentDiff');
    },
    handleChangeAffix(status){
      this.showSmallRow=status;
    },
    // 获取到申诉ids
    changeAppealIds(postId, appealPersonId){
       if (postId && appealPersonId) {
        this.getCheckAppealDetail(postId, appealPersonId);
      }
    },
    getCheckAppealDetail(postId,appealPersonId){
      getAppealDetail({
        appealPersonId: appealPersonId,
        postId: postId,
        employerId:this.$route.query.employerId?this.$route.query.employerId:''
      }).then(res => {
        if (res.code == 0) {
          this.list = res.data;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.btn-before{
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform:translateX(-65px) ;
  z-index: 9;
}
.com-progress {
  margin-bottom: 20px;
  padding: 20px 40px;
  background: #fff;
}
.tabs-wrapper{
  background: #fff;
}
.smallHeight{
  margin-top: 0px;
}
.normalHeight{
  margin-top: 20px;
}</style>
